import { render } from "./zaku-product-request-update.vue?vue&type=template&id=4cae02a5"
import script from "./zaku-product-request-update.vue?vue&type=script&lang=js"
export * from "./zaku-product-request-update.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__